<template>
    <section class="d-inline">
        <b-navbar type="dark" fixed="top" v-bind:sticky.boolean="true" class="background-primary navbar-expand-lg shadow-sm" variant="danger">
            <router-link v-bind:to="{ name: 'index' }" class="navbar-brand">
                <img src="/static/images/logo.png" />
                <span class="h4 font-weight-bold text-uppercase ml-3">Administration</span>
            </router-link>
            <b-navbar-toggle target="navbar-header" class="btn btn-outline-danger text-white ">
                <i class="fa fa-bars"></i>
            </b-navbar-toggle>
            <b-collapse id="navbar-header" is-nav>
                <ul class="ml-auto navbar-nav flex-md-column flex-lg-row flex-row text-right float-md-right">
                    <li class="nav-item ml-3 text-white">
                        Tahun Ajaran: 
                    </li>
                    <b-nav-item-dropdown right no-caret class="no-hover">
                        <template slot="button-content">
                            <u class="text-white">{{ selectedTerm.name }}</u>
                        </template>
                        <template v-for="term in terms">
                            <b-dropdown-item class="bg-white text-danger" v-if="term.id === selectedTerm.id">
                                <u>{{ term.name }}</u>
                            </b-dropdown-item>
                            <b-dropdown-item class="bg-white text-danger" v-on:click.self="selectedTerm = term" v-else>
                                {{ term.name }} 
                            </b-dropdown-item>
			    <!--<b-dropdown-item class="bg-white text-danger" v-on:click.self="selectedTerm = term" v-else>
                                {{ term.name }} <i class="fa fa-trash float-right my-1" v-b-tooltip v-bind:title="'Hapus Tahun Ajaran ' + term.name" v-on:click.prevent="modal.remove = true; reference = term"></i>
                            </b-dropdown-item>-->	
                        </template>
                        <b-dropdown-item v-on:click="modal.add = true">
                            + Buat Tahun Ajaran Baru
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <li class="nav-item ml-md-3 ml-auto">
                        <div v-if="profile.isAdmin" class="rounded-circle badge-circle ml-1 text-uppercase" title="Administrator">
                            A
                        </div>
                        <template v-if="profile.isEmployee">
                            <div v-for="role in roles" v-if="profile.employee['is' + role.id]" class="rounded-circle badge-circle ml-1 text-uppercase" v-bind:title="role.name">
                                {{ abbr(role.name) }}
                            </div>
                        </template>
                    </li>
                    <router-link v-bind:to="{ name: 'index' }" v-bind:tag="'li'" class="nav-item ml-3">
                        <a class="nav-link font-weight-light">
                            {{ profile.name }}
                        </a>
                    </router-link>
                    <b-nav-item-dropdown right no-caret class="ml-3">
                        <template slot="button-content">
                            <i class="fa fa-ellipsis-h"></i>
                        </template>
                        <b-dropdown-item v-on:click="logout">
                            Sign Out 
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </ul>
                <sidebar-view></sidebar-view>
            </b-collapse>
        </b-navbar>
        <b-modal v-model="modal.add" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true" v-if="roleElligible()">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Menambahkan Tahun Ajaran
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="add">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 required">Tahun Ajaran</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input v-model="form.name" maxlength="20" class="form-control h4 mb-0 font-weight-medium form-control-sm" v-bind:placeholder="$moment().format('YYYY') + '-' + (parseInt($moment().format('YYYY')) + 1)" required />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Simpan
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.add = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-if="roleElligible()" v-model="modal.remove" v-on:hide="reference = null; removeConfirmationCount = 0;" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">
                            Apa yakin mau menghapus Tahun Ajaran ini? Karena jika sudah terhapus data tidak dapat dikembalikan.
                            <template v-if="removeConfirmationCount > 1">
                                PERINGATAN {{ removeConfirmationCount }}
                            </template>
                        </h4>
                    </div>
                    <div class="col-12">
                        <button type="button" class="btn btn-outline-danger btn-sm px-5" v-on:click="removeConfirmationCount >= 2 ? remove() : removeConfirmationCount += 1">
                            Ya
                        </button>
                        <button type="button" class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Sidebar from "@/components/layouts/Sidebar";
    import { employeeRoles } from '@/params.js';

    export default {
        name: "Header",
        components: {
            "sidebar-view": Sidebar
        },
        computed: mapState([
            'profile'
        ]),
        watch: {
            selectedTerm(term) {
                this.$store.dispatch('setTerm', term);
            }
        },
        data() {
            return {
                roles: [],
                terms: [],
                selectedTerm: {},
                form: {
                    name: ''
                },
                reference: null,
                removeConfirmationCount: 1,
                modal: {
                    add: false,
                    remove: false
                }
            };
        },
        methods: {
            add() {
                this.axios.post(process.env.API_URL + '/term', this.form).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.add = false;
                        for (let attribute in this.form) {
                            this.form[attribute] = '';
                        }
                        this.fetchData();
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            remove() {
                if (this.reference && confirm('Apa yakin mau menghapus Tahun Ajaran ' + this.reference.name + '? Karena jika sudah terhapus data tidak dapat dikembalikan.')) {
                    this.axios.post(process.env.API_URL + '/term/delete/' + this.reference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.modal.remove = false;
                            this.fetchData();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                }
            },
            abbr(string) {
                var abbr = '';
                var words = string.split(' ');
                for (var i = 0; i < words.length; i++) {
                    abbr += words[i].charAt(0);
                }
                return abbr;
            },
            roleElligible() {
                return this.profile.isAdmin;
            },
            logout() {
                this.$store.dispatch('logout').then(() => {
//                    this.$router.replace({name: 'authenticate/login'});
                    location.reload();
                });
            },
            fetchData() {
                this.axios.get(process.env.API_URL + '/term').then(response => {
                    this.terms = response.data.data;
                    this.selectedTerm = this.terms.find(term => term.id === parseInt(localStorage.getItem('termID'))) || this.terms[0];
                });
            }
        },
        created() {
            this.fetchData();
            this.roles = employeeRoles;
        }
    };
</script>
<style scoped>
    .navbar .badge-circle.rounded-circle{
        height: 25px;
        width: 25px;
        background-color: #fff;
        color: #DA1A31;
        font-size: 0.8rem;
        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        padding: 2.5px;
    }
    .navbar ul.navbar-nav li{
        font-size: 0.9rem;
        letter-spacing: 0.04rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/layouts/Header.vue